import PortraitName from './PortraitName';

export default PortraitName;
export { PortraitName };
